import { FinanceCalculationParams } from '../../../api/graphql/generated/schema';
import { PaymentCalculationConfig } from './interfaces';

export class CalculationConfigDto {
  private _automaticCalculation?: boolean = false;
  private _insuranceId?: number;
  private _insurancePackageId?: number;
  private _insuranceWindshieldLimit?: number;
  private _insuranceDeductible?: number;
  private _carPriceDiscount: number;
  private _contraAccount?: boolean | null;
  private _totalModelPrice: number;
  private _regDateFirst: Date;
  private _productId?: string;
  private _claimFreeMonths?: number;
  private _clientAge?: number;

  constructor(input: Partial<FinanceCalculationParams>) {
    this._automaticCalculation = input.automaticCalculation;
    this._insuranceId = input.insuranceId;
    this._insurancePackageId = input.insurancePackageId;
    this._insuranceWindshieldLimit = input.insuranceWindshieldLimit;
    this._insuranceDeductible = input.insuranceDeductible;
    this._carPriceDiscount = input.carPriceDiscount;
    this._contraAccount = input.contraAccount;
    this._totalModelPrice = input.totalModelPrice;
    this._regDateFirst = input.regDateFirst;
    this._productId = input.productId;
    this._claimFreeMonths = input.claimFreeMonths || undefined;
    this._clientAge = input.clientAge || undefined;
  }

  static convertFromCalculationInput(input: PaymentCalculationConfig) {
    return new CalculationConfigDto({
      productId: input.productId,
      automaticCalculation: input.automaticCalculation,
      insuranceId: input.id,
      insurancePackageId: input.packageId,
      insuranceDeductible: input.deductible,
      insuranceWindshieldLimit: input.windshieldLimit,
      carPriceDiscount: input.carPriceDiscount,
      contraAccount: input.contraAccount,
      totalModelPrice: input.totalModelPrice,
      regDateFirst: input.regDateFirst,
      claimFreeMonths: input.claimFreeMonths || undefined,
      clientAge: input.clientAge || undefined,
    });
  }

  public get regDateFirst(): Date {
    return this._regDateFirst;
  }
  public get totalModelPrice(): number {
    return this._totalModelPrice;
  }
  public get contraAccount(): boolean | undefined | null {
    return this._contraAccount;
  }
  public get carPriceDiscount(): number {
    return this._carPriceDiscount;
  }
  public get insuranceDeductible(): number | undefined {
    return this._insuranceDeductible;
  }
  public get insuranceWindshieldLimit(): number | undefined {
    return this._insuranceWindshieldLimit;
  }
  public get insurancePackageId(): number | undefined {
    return this._insurancePackageId;
  }
  public get insuranceId(): number | undefined {
    return this._insuranceId;
  }
  public get automaticCalculation(): boolean | null | undefined {
    return this._automaticCalculation;
  }
  public get productId(): string | undefined {
    return this._productId;
  }
  public get claimFreeMonths(): number | undefined {
    return this._claimFreeMonths;
  }
  public get clientAge(): number | undefined {
    return this._clientAge;
  }
}
